import React from 'react'
import * as S from './Skeleton.styled'
import type { SkeletonProps, SkeletonShapeProps } from './types'

export const Skeleton = ({ gap = 0, aligment = 'vertical', children, ...props }: SkeletonProps) => {
  return (
    <S.Skeleton $gap={gap} $aligment={aligment} data-testid="Skeleton" {...props}>
      {children}
    </S.Skeleton>
  )
}

export const SkeletonShape = ({
  variant = 'rectangle',
  radius,
  width = '100%',
  height = 'auto',
  ...props
}: SkeletonShapeProps) => {
  return (
    <S.Shape
      $variant={variant}
      $radius={radius}
      $width={width}
      $height={height}
      data-testid="Skeleton.Shape"
      {...props}
    >
      &zwnj;
    </S.Shape>
  )
}

Skeleton.Shape = SkeletonShape
